import cookies from 'js-cookie';

export function userHasIdToken() {
  return cookies.get('id_token') !== undefined;
}
